import { ConfirmationTypesEnum } from '@common/enums';

export const confirmationTypeLabels = new Map<ConfirmationTypesEnum, string>([
  [ConfirmationTypesEnum.Sms, 'SMS код'],
  [ConfirmationTypesEnum.Email, 'Код из email'],
  [ConfirmationTypesEnum.Otp, 'Код из Google Authenticator'],
]);
